
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/p/[alias]/[pid]/[variant]",
      function () {
        return require("private-next-pages/p/[alias]/[pid]/[variant].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/p/[alias]/[pid]/[variant]"])
      });
    }
  